/* Osharē cart drawer helpers — product recommendations loader.
   Fires whenever the cart drawer is opened or its contents are re-rendered. */

(function () {
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    // Lean on Shopify's formatMoney if present, else fall back.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}'); } catch (e) {}
    }
    var amount = (cents / 100).toFixed(0);
    return amount + ' ' + (window.Shopify && window.Shopify.currency && window.Shopify.currency.active || '');
  }

  function buildRecCard(product) {
    var variant = (product.variants && product.variants[0]) || {};
    var hasMultipleVariants = product.variants && product.variants.length > 1;
    var firstAvailable = (product.variants || []).find(function (v) { return v.available; }) || variant;
    var img = product.featured_image || (product.media && product.media[0] && product.media[0].preview_image && product.media[0].preview_image.src);

    var card = document.createElement('div');
    card.className = 'oshare-cart__rec-card';

    var variantOptions = '';
    if (hasMultipleVariants) {
      variantOptions = '<select class="oshare-cart__rec-variant" data-product="' + escapeHtml(product.id) + '">' +
        (product.variants || []).map(function (v) {
          return '<option value="' + escapeHtml(v.id) + '"' + (v.id === firstAvailable.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
            escapeHtml(v.title) + (v.available ? '' : ' (sold out)') + '</option>';
        }).join('') +
        '</select>';
    }

    card.innerHTML =
      '<a href="' + escapeHtml(product.url) + '" class="oshare-cart__rec-image">' +
        (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
      '</a>' +
      '<a href="' + escapeHtml(product.url) + '" class="oshare-cart__rec-name">' + escapeHtml(product.title) + '</a>' +
      '<span class="oshare-cart__rec-price">' + formatMoney(firstAvailable.price || product.price) + '</span>' +
      variantOptions +
      '<button type="button" class="oshare-cart__rec-add" data-variant="' + escapeHtml(firstAvailable.id) + '">Add to cart</button>';

    var addBtn = card.querySelector('.oshare-cart__rec-add');
    var select = card.querySelector('.oshare-cart__rec-variant');
    if (select) {
      select.addEventListener('change', function () { addBtn.dataset.variant = select.value; });
    }
    addBtn.addEventListener('click', function () {
      var variantId = addBtn.dataset.variant;
      if (!variantId) return;
      if (typeof window.addToCartShopify === 'function') {
        window.addToCartShopify(variantId, 1, addBtn);
      } else {
        // Fallback: direct cart add
        addBtn.textContent = 'Adding…'; addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          addBtn.textContent = 'Added ✓';
          // Refresh drawer
          var cd = document.querySelector('cart-drawer');
          if (cd && typeof cd.getSectionsToRender === 'function') {
            fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
              .then(function (r) { return r.json(); })
              .then(function (data) {
                cd.getSectionsToRender().forEach(function (s) {
                  var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
                  if (el && data[s.id]) {
                    el.innerHTML = cd.getSectionInnerHTML(data[s.id], s.selector);
                  }
                });
              });
          }
        }).catch(function () {
          addBtn.textContent = 'Error'; addBtn.disabled = false;
        });
      }
    });

    return card;
  }

  function loadRecommendations() {
    var wrap = document.getElementById('OshareCartRecs');
    var list = document.getElementById('OshareCartRecsList');
    if (!wrap || !list) return;
    var productId = wrap.dataset.firstProduct;
    if (!productId) { wrap.style.display = 'none'; return; }

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) {
          // Fallback: fetch from /products.json (all products) and exclude the current one
          return fetch('/products.json?limit=8')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              return (d.products || []).filter(function (p) { return String(p.id) !== String(productId); });
            });
        }
        return products;
      })
      .then(function (products) {
        if (!products || !products.length) { wrap.style.display = 'none'; return; }
        list.innerHTML = '';
        products.slice(0, 6).forEach(function (p) { list.appendChild(buildRecCard(p)); });
      })
      .catch(function () { wrap.style.display = 'none'; });
  }

  // Run on initial page load if drawer present
  document.addEventListener('DOMContentLoaded', loadRecommendations);

  // Also run after the drawer is re-rendered (renderContents updates DOM)
  // We watch for the recs element appearing.
  var observer = new MutationObserver(function () {
    var wrap = document.getElementById('OshareCartRecs');
    if (wrap && !wrap.dataset.loaded) {
      wrap.dataset.loaded = '1';
      loadRecommendations();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
